var questionnaries = [
 {
   "indicator": "i11",
   "type": "unique",
   "title": "Avant de commencer, nous aimerions en savoir un peu plus sur…",
   "series": "introduction",
   "question": "Votre catégorie d'âge",
   "option1": "Moins de 20 ans",
   "option2": "20 - 39 ans",
   "option3": "Plus de 40 ans",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i12",
   "type": "unique",
   "title": "Avant de commencer, nous aimerions en savoir un peu plus sur…",
   "series": "introduction",
   "question": "Votre plus haute formation",
   "option1": "Ecole obligatoire, Ecole de culture générale",
   "option2": "Apprentissage, Ecole professionnelle",
   "option3": "Maturité, Formation professionnelle supérieure",
   "option4": "Formation universitaire, Haute école",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i13",
   "type": "unique",
   "title": "Avant de commencer, nous aimerions en savoir un peu plus sur…",
   "series": "introduction",
   "question": "Votre langue maternelle",
   "option1": "Français",
   "option2": "Autre",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i14",
   "type": "unique",
   "title": "Connaissez-vous la ville de Lausanne?",
   "series": "lausanne knowledge",
   "question": "Vous êtes originaire de…",
   "option1": "Lausanne et région",
   "option2": "Suisse romande",
   "option3": "Reste de la Suisse",
   "option4": "Hors de la Suisse",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i15",
   "type": "unique",
   "title": "Le Géoguide fonctionne sur votre téléphone, c'est super! Mais vous…",
   "series": "user habits",
   "question": "Vous utilisez des smartphones/tablettes tactile",
   "option1": "Moins d'une fois par semaine",
   "option2": "1 à 7 fois par semaine",
   "option3": "Plusieurs fois par jour",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i16",
   "type": "unique",
   "title": "Le Géoguide fonctionne sur votre téléphone, c'est super! Mais vous…",
   "series": "user habits",
   "question": "Vous utilisez internet",
   "option1": "Moins d'une fois par semaine",
   "option2": "1 à 7 fois par semaine",
   "option3": "Plusieurs fois par jour",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i17",
   "type": "slider",
   "title": "Vous êtes sur le bon chemin!",
   "series": "user abilities",
   "question": "Sur une échelle de 1 à 5, évaluez votre niveau dans les domaines suivants (1 =faible, 5=élevé)",
   "option1": "Lecture de carte",
   "option2": "Sens de l'orientation",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i18",
   "type": "slider",
   "title": "Le Géoguide contient beaucoup d'informations sur des domaines très spécifiques… Et vous, qu'est-ce qui vous intéresse?",
   "series": "",
   "question": "Sur une échelle de 1 à 5, évaluez votre intérêt dans ces différents domaines (1 =faible, 5=élevé)",
   "option1": "Géologie",
   "option2": "Géomorphologie",
   "option3": "Hydrologie, Glaciologie",
   "option4": "Urbanisme",
   "option5": "Histoire",
   "img": ""
 },
 {
   "indicator": "i19",
   "type": "unique",
   "title": "Avant de commencer, nous aimerions en savoir un peu plus sur…",
   "series": "introduction",
   "question": "Avez-vous fait des études en Géosciences?",
   "option1": "Oui",
   "option2": "Non",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i21",
   "type": "unique",
   "title": "Nous sommes enfin arrivés, mais nous avons encore quelques petites questions!",
   "series": "",
   "question": "De manière générale, vous avez trouvé les textes explicatifs",
   "option1": "Très intéressants",
   "option2": "Plutôt intéressants",
   "option3": "Peu intéressants",
   "option4": "Pas intéressants du tout",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i22",
   "type": "",
   "title": "",
   "series": "",
   "question": "",
   "option1": "",
   "option2": "",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i23",
   "type": "unique",
   "title": "Nous sommes enfin arrivés, mais nous avons encore quelques petites questions!",
   "series": "",
   "question": "De manière générale, vous avez trouvé les quiz",
   "option1": "Très intéressants",
   "option2": "Plutôt intéressants",
   "option3": "Peu intéressants",
   "option4": "Pas intéressants du tout",
   "option5": "Je n'ai pas fait les quiz!",
   "img": ""
 },
 {
   "indicator": "i24",
   "type": "unique",
   "title": "Nous sommes enfin arrivés, mais nous avons encore quelques petites questions!",
   "series": "",
   "question": "De manière générale, vous avez trouvé les lieux présentés",
   "option1": "Très intéressants",
   "option2": "Plutôt intéressants",
   "option3": "Peu intéressants",
   "option4": "Pas intéressants du tout",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i25",
   "type": "unique",
   "title": "Connaissez-vous la ville de Lausanne?",
   "series": "lausanne knowledge",
   "question": "Combien de fois avez-vous déjà effectué le parcours du Géoguide Lausanne?",
   "option1": "Jamais, c'est la première fois",
   "option2": "Une fois",
   "option3": "Deux fois ou plus",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i311",
   "type": "unique",
   "title": "Commençons par un petit test de connaissance",
   "series": "introduction",
   "question": "Le relief Lausannois a notamment été dessiné par deux rivières. Il s'agit de :",
   "option1": "La Louve et La Sorge",
   "option2": "La Louve et La Venoge",
   "option3": "La Louve et Le Flon",
   "option4": "La Venoge et Le Flon",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i312",
   "type": "unique",
   "title": "Commençons par un petit test de connaissance",
   "series": "introduction",
   "question": "En géomorphologie, lequel de ces termes désigne une forme sédimentaire d'origine glaciaire? ",
   "option1": "Un éboulis",
   "option2": "Une gorge",
   "option3": "Une moraine",
   "option4": "Un bassin versant",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i313",
   "type": "unique",
   "title": "Commençons par un petit test de connaissance",
   "series": "introduction",
   "question": "A Lausanne, lequel de ces quartiers n'a pas connu de projet d'aménagement d'envergure durant les deux derniers siècles?",
   "option1": "Le Flon",
   "option2": "La Cité",
   "option3": "La Riponne",
   "option4": "Le Vallon",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i314",
   "type": "unique",
   "title": "",
   "series": "introduction",
   "question": "",
   "option1": "",
   "option2": "",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i315",
   "type": "unique",
   "title": "Commençons par un petit test de connaissance",
   "series": "introduction",
   "question": "Dans l'histoire de Lausanne, lequel de ces éléments n'a pas eu d'impact sur la structure de la ville d'aujourd'hui?",
   "option1": "Les grands projets d'aménagement urbains",
   "option2": "L'hydrographie",
   "option3": "Le climat",
   "option4": "La topographie",
   "option5": "Aucun; tous ces éléments ont joué un rôle dans la structure de la ville telle que nous la connaissons aujourd'hui",
   "img": ""
 },
 {
   "indicator": "i321",
   "type": "unique",
   "title": "Revenons aux questions de départ!",
   "series": "conclusion",
   "question": "Le relief Lausannois a notamment été dessiné par deux rivières. Il s'agit de :",
   "option1": "Le Flon et La Sorge",
   "option2": "La Louve et La Venoge",
   "option3": "La Louve et Le Flon",
   "option4": "La Venoge et Le Flon",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i322",
   "type": "unique",
   "title": "Revenons aux questions de départ!",
   "series": "conclusion",
   "question": "En géomorphologie, lequel de ces termes désigne une forme sédimentaire d'origine glaciaire? ",
   "option1": "Un éboulis",
   "option2": "Une gorge",
   "option3": "Une moraine",
   "option4": "Un bassin versant",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i323",
   "type": "unique",
   "title": "Revenons aux questions de départ!",
   "series": "conclusion",
   "question": "A Lausanne, lequel de ces quartiers n'a pas connu de projet d'aménagement d'envergure durant les deux derniers siècles?",
   "option1": "Le Flon",
   "option2": "La Cité",
   "option3": "La Riponne",
   "option4": "Le Vallon",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i324",
   "type": "unique",
   "title": "",
   "series": "conclusion",
   "question": "",
   "option1": "",
   "option2": "",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i325",
   "type": "unique",
   "title": "Revenons aux questions de départ!",
   "series": "conclusion",
   "question": "Dans l'histoire de Lausanne, lequel de ces éléments n'a  pas impacté la structure de la ville d'aujourd'hui?",
   "option1": "Les grands projets d'aménagement urbains",
   "option2": "L'hydrographie",
   "option3": "Le climat",
   "option4": "La topographie",
   "option5": "Aucun; tous ces éléments ont joué un rôle dans la structure de la ville telle que nous la connaissons aujourd'hui",
   "img": ""
 },
 {
   "indicator": "i33",
   "type": "",
   "title": "",
   "series": "",
   "question": "",
   "option1": "",
   "option2": "",
   "option3": "",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i411",
   "type": "unique",
   "title": "Connaissez-vous la ville de Lausanne?",
   "series": "lausanne knowledge",
   "question": "Pourriez-vous dire dans lequel de ces quartier a été prise cette photographie?",
   "option1": "Quartier de la Gare",
   "option2": "Le Flon",
   "option3": "Ouchy",
   "option4": "Le Vallon",
   "option5": "",
   "img": "i41img1.jpg"
 },
 {
   "indicator": "i412",
   "type": "unique",
   "title": "Connaissez-vous la ville de Lausanne?",
   "series": "lausanne knowledge",
   "question": "Pourriez-vous dire dans lequel de ces quartier a été prise cette photographie?",
   "option1": "Le Vallon",
   "option2": "Quartier de la Gare",
   "option3": "Grancy",
   "option4": "Le Flon",
   "option5": "",
   "img": "i41img2.jpg"
 },
 {
   "indicator": "i413",
   "type": "unique",
   "title": "Connaissez-vous la ville de Lausanne?",
   "series": "lausanne knowledge",
   "question": "Parmi ces grans édifices lausannois, lequel n'apparaît pas sur cette photo?",
   "option1": "Le Palais de Rhumine",
   "option2": "La Cathédrale",
   "option3": "La Tour Bel-Air",
   "option4": "L'Eglise St-François",
   "option5": "",
   "img": "i41img3.jpg"
 },
 {
   "indicator": "i42",
   "type": "unique",
   "title": "Pourriez-vous nous en dire plus sur vos loisirs?",
   "series": "user preferences",
   "question": "Parmi ces loisirs, lequel appréciez-vous le plus?",
   "option1": "Les randonnées en montagne",
   "option2": "Les promenades en nature",
   "option3": "Les promenades en ville",
   "option4": "",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i43",
   "type": "unique",
   "title": "Pourriez-vous nous en dire plus sur vos loisirs?",
   "series": "user preferences",
   "question": "En moyenne, à quelle fréquence faites-vous des marches (randonnées, promenades) pour votre plaisir?",
   "option1": "Quelques fois par an",
   "option2": "Environ une fois par mois",
   "option3": "Plusieurs fois par mois",
   "option4": "Une fois par semaine ou plus",
   "option5": "",
   "img": ""
 },
 {
   "indicator": "i44",
   "type": "slider",
   "title": "Pourriez-vous nous en dire plus sur vos loisirs?",
   "series": "user preferences",
   "question": "Sur une échelle de 1 à 5, évaluez l'importance des critères suivants lorsque vous faites une marche",
   "option1": "Performance physique (distance, durée, vitesse)",
   "option2": "Bien-être personnel",
   "option3": "Découverte de nouveaux lieux",
   "option4": "Qualité esthétique des lieux",
   "option5": "Historique des lieux",
   "img": ""
 },
 {
   "indicator": "i45",
   "type": "unique",
   "title": "Nous allons bientôt partir à la re-découverte de Lausanne",
   "series": "Introduction",
   "question": "Le long du parcours du Géoguide, vous souhaitez avant tout",
   "option1": "En apprendre sur la ville et sa géographie",
   "option2": "Découvrir des lieux ainsi que leur histoire",
   "option3": "Faire une promenade sympathique",
   "option4": "Je n'ai pas d'attente patriculières",
   "option5": "",
   "img": ""
 }
]

export default questionnaries;



// WEBPACK FOOTER //
// ./src/data/questionnaries.js